import { MAX_PRICE_INPUT_NAME, MIN_PRICE_INPUT_NAME } from './constants'

export default {
  minPrice: MIN_PRICE_INPUT_NAME,
  maxPrice: MAX_PRICE_INPUT_NAME,
  minPriceLabel: 'Minimum price',
  maxPriceLabel: 'Maximum price',
  priceInputType: 'text',
  required: true
}
